<template>
  <div id="main-content">
    <a-form layout="inline" style="background: #ffffff;padding: 10px;margin-bottom: 10px;border-radius: 10px;">
      <a-form-item>
        <a-select style="width: 200px" v-model="channel" allowClear @change="changeChannel"
                  optionFilterProp="label" placeholder="请选择渠道">
          <a-select-option v-for="channelItem in $store.state.SpendChannel"
                           :value="channelItem.value"
                           :label="channelItem.name"
                           :key="channelItem.value">
            {{channelItem.name}}
          </a-select-option>
        </a-select>
      </a-form-item>
      <a-form-item>
        <a-select style="width: 200px" v-model="account"
                  show-search allowClear @change="init_data"
                  optionFilterProp="label" placeholder="请选择代理商">
          <a-select-option :value="accountIndex" :label="accountItem" :key="accountIndex"
                           v-for="(accountItem,accountIndex) in accountList">
            {{accountItem}}
          </a-select-option>
        </a-select>
      </a-form-item>
      <a-form-item>
        <a-radio-group button-style="solid" v-model="cate" @change="init_data">
           <a-radio-button value="">
             全部
           </a-radio-button>
           <a-radio-button value="game">
             游戏
           </a-radio-button>
           <a-radio-button value="ai">
             AI
           </a-radio-button>
         </a-radio-group>
      </a-form-item>
    </a-form>
    <a-table :columns="getTableColumns" id="show-table"
             style="flex: 1;overflow-y: hidden;background: #ffffff"
             :scroll="{ x: '500px',y: _get_table_scroll({id:'show-table'}) }" :data-source="tableData"
             :rowKey="item=>item.date" :loading="tableLoad"
             bordered :pagination="false">
      <template slot="date" slot-scope="text,recode">
        {{recode.start_date}} - {{recode.end_date}}
      </template>
      <template slot="account" slot-scope="text,recode">
        {{accountList[text]}}
      </template>
      <template slot="country" slot-scope="text,recode">
        <a-tag :key="country_item" v-for="country_item in JSON.parse(text)">{{country_item}}</a-tag>
      </template>
      <template slot="advertiser" slot-scope="text,recode">
        <a-tag :key="advertiser_item" v-for="advertiser_item in JSON.parse(text)">
          {{advertiserList[advertiser_item]}}
        </a-tag>
      </template>
      <template slot="action" slot-scope="text,recode">
        <a-button type="danger" size="small" ghost @click="deleteConfig(recode.id)">删除</a-button>
      </template>
    </a-table>
  </div>
</template>

<script>
import ConfigPanel from "./ConfigPanel";
import ClosePanel from "./ClosePanel";
import {
  DeleteConfigSpendRebate,
  GetAccountAdvertiser,
  GetConfigSpendRebate,
  GetSpendRebate
} from "../../../api/v1/spend_rebate_api";
export default {
  name: "Config",
  data(){
    return {
      channel:undefined,
      account:undefined,
      cate: '',
      tableLoad:false,
      tableData:[],
      accountList:{},
      advertiserList:{},
    }
  },
  computed:{
    getTableColumns(){
      let _table_columns = [
        { title: '日期', width:'200px', dataIndex: 'date',scopedSlots: { customRender: 'date' },align:'center'},
        { title: '渠道', width:'100px', dataIndex: 'channel',align:'center'},
        { title: '代理商', width:'100px', dataIndex: 'account',scopedSlots: { customRender: 'account' },align:'center'},
        { title: '账户', dataIndex: 'advertiser',scopedSlots: { customRender: 'advertiser' },align:'center'},
        { title: '国家', width:'150px', dataIndex: 'country',scopedSlots: { customRender: 'country' },align:'center'},
        { title: '返点比例', width:'80px', dataIndex: 'ratio', scopedSlots: { customRender: 'installs' },align:'center'},
        { title: '操作', key: 'action', scopedSlots: { customRender: 'action' },width:'100px',align:'center'},
      ]
      return _table_columns
    }
  },
  mounted() {
    this.changeChannel()
  },
  methods:{
    deleteConfig(id){
      let _this = this
      this.$confirm({
        title: '删除返点配置项?',
        content: '此删除将会删除该配置下的返点数据，请知悉',
        onOk() {
          DeleteConfigSpendRebate({id:id}).then(resp => {
            if (resp.code===200){
              _this.$message.success(resp.msg)
              _this.init_data()
            }else{
              _this.$message.error(resp.msg)
            }
          })
        },
        onCancel() {},
      });
    },
    changeChannel(){
      GetAccountAdvertiser({
        channel:this.channel,
        account:this.account
      }).then(resp => {
        if (resp.code == 200){
          this.advertiser = []
          this.accountList = resp.data.account_list
          resp.data.advertiser_list.forEach(item=>{
            this.advertiserList[item.advertiser_id] = item.name
          })
        }
      })
      this.init_data()
    },
    init_data(){
      this.tableLoad = true
      GetConfigSpendRebate({
        channel:this.channel,
        account:this.account,
        cate:this.cate,
      }).then(resp => {
        this.tableLoad = false
        if (resp.code===200){
          this.tableData = resp.data
        }
      })
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/Spend/Rebate/Config.vue